import React, { useState } from "react";
import Menu from "./Menu";
import "./App.css";
import MenuIcon from '@mui/icons-material/Menu';
import ThumbUpTwoToneIcon from "@mui/icons-material/ThumbUpTwoTone";
import ThumbDownTwoToneIcon from "@mui/icons-material/ThumbDownTwoTone";

import {
  Box,
  Card,
  cardContent,
  Typography,
  Button,
  CardMedia,
} from "@mui/material";

const Gallery = () => {
  const [item, setitem] = useState(Menu);

  

  const filterItem = (cateItem)=>{
    const updateItem = Menu.filter((curEle)=>{
      return curEle.category === cateItem

    })
    setitem(updateItem)

  }



  return (
    <>
      <div className="navbar">
        <div className="logo">
          MY <span>GALLERY</span>
        </div>
        <div className="links" >
          <ul>
            <li onClick={()=> setitem(Menu)} >All</li>
            <li onClick={()=> filterItem('home')}>Home</li>
            <li onClick={()=> filterItem('dog')}>dogs</li>
            <li onClick={()=> filterItem('cat')}>cats</li>
          </ul>
        </div>

        <div className="ham">
      <MenuIcon  />
        </div>
      </div>

      {/* miaine */}

      <div className="container">


      {item.map((elem) => {
        const { id, image, name, description } = elem;

        return (
          <>
          <div className="box" id="box">

              <Box width="290px" >
                <Card>
                  <div className="data">
                    <CardMedia>
                      <div className="img">
                        <img src={image} alt="name" />
                      </div>
                    </CardMedia>

                    <cardContent padding={"10px"}>
                      <div className="type">
                        <Typography gutterBottom variant="h5" componant="div">
                          <p>{id}</p>
                          <p>{name}</p>
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                       <h4>
                       description: 
                        </h4> 
                       {description}
                        </Typography>
                      </div>
                    </cardContent>
                    <div className="btn">
                    <div className="buttons">
                      
                      <ThumbUpTwoToneIcon id="btn" />
                    </div>
                    <div className="buttons">
                      <ThumbDownTwoToneIcon id="btn" />
                    </div>
                    </div>
                  </div>
                </Card>
              </Box>
      </div>
          </>
        );
      })}
      </div>
    </>
    );
};

export default Gallery;
